import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { CogNeedTextField } from '@cogneed/react-utils';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { DatePickerProps } from '@mui/x-date-pickers/DatePicker';

export default function CogNeedKeyboardDatePicker(props: Omit<DatePickerProps<Date | null, Date | null>, 'renderInput'>) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DesktopDatePicker
        {...props}
        renderInput={(params) => <CogNeedTextField {...params} />}
      />
    </LocalizationProvider>
  );
}
